
import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import Auth from "@/lib/common/auth";
import ModalTitle from "@/lib/model/exam/modal-title";
import ModalHeader from "@/components/modal-header.vue";

@Component({
  components: {
    ModalHeader
  }
})
export default class DelExamModal extends Vue {
  name = "async-download-modal";
  text = "";
  checkMe = false;
  modalTitle: ModalTitle = new ModalTitle();
  @Prop() private isShowDownloadModal!: boolean;

  @Emit("on-download-close")
  downloadClose() {
    return;
  }

  mounted() {
    this.modalTitle.title = "导出任务创建成功";
    this.modalTitle.hasDesc = false;
  }

  toDownloadLog() {
    this.downloadClose();
    const exportListUrl = `/export/list?companyId=${Auth.companyId}`;
    window.open(exportListUrl);
  }
}
